import React from 'react';
import LikeIcon from "@/components/icons/LikeIcon";

const DislikeButton = ({color='#1D2142', selected, onClick}) => {
	return (
		<button className={`flex items-center rounded-full p-2 cursor-pointer ${selected ? 'bg-danger' : ''}`} onClick={onClick} aria-label='Dislike' data-testid={`button-dislike`}>
			<LikeIcon className={'rotate-180'} color={selected ? 'white' : color} />
		</button>
	);
};

export default DislikeButton;
